import createClient from '../../apolloClient';
import QUERY_ESIMS from '../../query/esims';

const fetchEsims = async (variables) => {
  const client = createClient();
  const result = await client.query({
    query: QUERY_ESIMS,
    variables,
  });
  const { esims } = result?.data || {};
  if (!esims?.isSuccess) throw esims.message;
  return esims.esims;
};

export default fetchEsims;
